export default "__VITE_ASSET__Dboc0LEU__"